/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { GetCourseCompletionsReportOptions, GetCourseCompletionsReportResponses } from '../../models/GetCourseCompletionsReport'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Get Course Completions
 * {@link /reports/course_completions}
 */
export function getCourseCompletionsReport<ThrowOnError extends boolean = true>(options: Options<GetCourseCompletionsReportOptions, ThrowOnError>): Promise<UnwrappedResult<GetCourseCompletionsReportResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/reports/course_completions', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<GetCourseCompletionsReportResponses, ThrowOnError>>
}
